import { unsafelyKeys } from "common/utilities/object";
import type { FilterCategories } from "domains/topicSearchFilter/types";
import type { RootState } from "types";

export const getTopicContentMetaIsLoaded = (state: RootState) => state.domains.topicContentMeta.isLoaded;

export const getLatestContentHasFilters = (state: RootState) => {
  const { filters } = state.domains.topicContentMeta;
  for (const key of unsafelyKeys(filters)) if (filters[key].length > 0) return true;
  return false;
};

export const getTopicFilters = (type: FilterCategories) => (state: RootState) =>
  state.domains.topicContentMeta.filters[type];

export const getContentHasFilters = (type: FilterCategories) => (state: RootState) =>
  getTopicFilters(type)(state).length > 0;
